<template>
	<BaseCatalogDetail v-slot="{item}" @load="onLoad">
		<Body class="catalog-detail-layout" />
		<div v-if="item" :class="['product-detail', item?.type == 'groupproduct' && 'product-detail-groupp']">
			<div class="wider-wrapper">
				<div class="cd-cols">
					<div class="cd-col1">
						<div class="cd-header"></div>
						<div class="cd-images">
							<div class="cd-hero-image" v-interpolation>
								<ClientOnly>
									<div class="cd-badge-container">
										<div v-if="item.discount_percent_custom > 0 || item.price_custom < item.basic_price" class="cd-badge-cnt">
											<span class="cd-badge cd-badge-discount">-{{item.discount_percent_custom}}%</span>
											<span class="cd-save"><BaseCmsLabel code="price_save" /> <span><BaseUtilsFormatCurrency :price="item.basic_price - item.price_custom" /></span></span>
										</div>
									
										<template v-if="hasSpecialBadges && item?.attributes_special?.length">
											<template v-for="(attr, index) in item.attributes_special.filter(a => a.attribute_code === 'posebne_oznake').slice(0, 4)" :key="index">
												<div v-if="attr.image_upload_path" class="cd-badge-item">
													<figure :class="['cd-badge-image', attr.code]">
														<BaseUiImage loading="lazy" :src="attr.image_upload_path" default="/images/no-image-50.jpg" :alt="attr.title ? attr.title : ''" />
													</figure>
													<div v-if="attr.title" class="cd-badge-title">{{attr.title}}</div>
												</div>
											</template>
										</template>
										<template v-if="Object.keys(item?.badge_coupons || {}).length">
											<template v-for="(coupon, id) in item?.badge_coupons" :key="id">
												<div class="cd-badge-coupon" v-if="coupon.image || (coupon.description && coupon.color_text && coupon.color_bg)">
													<div class="cd-badge-coupon-img" v-if="coupon.image">
														<BaseUiImage loading="lazy" :src="'/upload/'+coupon.image" default="/images/no-image-50.jpg" :alt="coupon.description" />
													</div>
													<div v-else class="cd-badge-coupon-text" :style="{'background-color': coupon.color_bg, 'color': coupon.color_text}">{{coupon.description}}</div>
												</div>
											</template>
										</template>
									</div>

									<CatalogSpecialBadges v-if="hasSpecialBadges && item?.attributes_special?.length" mode="cd" :item="item" :hasSpecialBadges="hasSpecialBadges" />
								</ClientOnly>

								<template v-if="item.images?.length">
									<BaseUiSwiper class="cd-hero-slider" :options="{effect: 'fade', fadeEffect: {crossFade: true}, navigation: {enabled: false}, on: {slideChange: (swiper) => activeSlide = swiper.activeIndex}}" @init="setMainSwiper">
										<BaseUiSwiperSlide v-for="(file, index) in item.images" :key="file.id" :class="['cd-hero-slide', index == 0 && 'cd-hero-slide-first']">
											<a :href="file.url" class="fancybox" rel="catalog" :data-index="index" :data-thumb="file.file_thumbs?.['width120-height120']?.thumb">
												<BaseUiImage :title="file.title" :alt="file.description" :loading="index == 0 ? 'eager' : 'lazy'" :data="file.file_thumbs?.['width485-height530']" default="/images/no-image-485.jpg" />
											</a>
										</BaseUiSwiperSlide>
									</BaseUiSwiper>	
	
									<ClientOnly>										
										<div v-if="item.images?.length > 1" class="fz0 cd-thumbs">
											<div class="cd-thumbs-wrapper">
												<div @click="mainSwiper.slideTo(index)" v-for="(thumb, index) in item.images" :key="index" :class="['cd-thumb', activeSlide == index && 'active']">
													<BaseUiImage loading="lazy" :data="thumb.file_thumbs?.['width120-height120']" default="/images/no-image-65.jpg" />
												</div>												
											</div>
										</div>										
									</ClientOnly>
								</template>							
								<template v-else>
									<img src="/media/images/no-image-700.jpg" alt="">
								</template>
							</div>
						</div>

						<ClientOnly>
							<CatalogSpecialBadgeDetail v-if="hasSpecialBadges && item?.attributes_special?.length" :item="item" />
						</ClientOnly>

						<div v-if="item.video_url" class="cd-video-url">
							<UiVideo :src="item.video_url" width="650" height="365" />
						</div>
					</div>
					<div class="cd-col2">
						<CmsBreadcrumbs v-if="item?.breadcrumbs" :items="item.breadcrumbs" mode="cd" />
						
						<div v-if="item?.scarcity_watching" class="cd-scarcity-watching" v-html="labels.get('scarcity').replace('%COUNTER%', item.scarcity_watching)"></div>

						<div :class="['cd-col2-intro-cnt', item.manufacturer_main_image && 'cd-col2-intro-cnt-brand-logo']">
					
							<NuxtLink v-if="item.manufacturer_main_image && item.manufacturer_url_without_domain" class="cd-brand-img" :to="item.manufacturer_url_without_domain">
								<BaseUiImage :data="item.manufacturer_main_image_thumbs?.['width160-height70']" default="/images/no-image-100.jpg" loading="lazy" />
							</NuxtLink>
							<div class="cd-category-code-cnt">
								<div v-if="item.category_url_without_domain && item.category_title" class="cd-category"><NuxtLink :to="item.category_url_without_domain">{{item.category_title}}</NuxtLink></div>
						
								<div class="cd-code">
									<div><span class="label"><BaseCmsLabel code="code" />:</span> <span>{{item.code}}</span></div>
								</div>
							</div>

							<div v-if="item.feedback_rate_widget?.rates_status || item.feedback_comment_widget?.comments_status" class="cd-rate-comments-cnt">				
								<div v-if="item.feedback_comment_widget?.comments_status > 1" class="cd-feedback">
									<div v-if="item.feedback_rate_widget?.rates" class="cd-rate">
										<FeedbackRates :rates="item.feedback_rate_widget.rates"/>
									</div>
								</div>
								<span v-if="item.feedback_comment_widget?.comments_status == 2 && item.feedback_comment_widget?.comments > 0 || item.feedback_comment_widget?.comments_status >= 3" class="catalog-product-comments">
									<div class="btn-comments" @click="activeTabs[5] = true; scrollTo('.cd-tab-comments', {offset: 80})"><BaseCmsLabel code="comments" /> ({{item.feedback_comment_widget?.comments ? item.feedback_comment_widget?.comments : 0}})</div>
								</span>
							</div>

							<h1 v-if="item.seo_h1" class="cd-title">{{item.seo_h1}}</h1>

							<div v-if="item?.type == 'groupproduct' && item?.groupproducts_ids" class="cd-groupp-cnt">
								<ClientOnly>
									<BaseCatalogProductsWidget :fetch="{id: item.groupproducts_ids.split(',').filter(id => id.trim() !== ''), limit: 20}" v-slot="{items: groupProducts}">
										<div v-if="groupProducts?.length" class="cd-groupp-title"><BaseCmsLabel code="group_product_title" /></div>
										<div v-if="groupProducts?.length" class="cd-groupp-items">
											<div v-for="item in groupProducts" :key="item.id" class="cd-groupp-item">
												<NuxtLink :to="item.url_without_domain">{{item.title}}</NuxtLink>											
											</div>
										</div>							
									</BaseCatalogProductsWidget>
								</ClientOnly>
							</div>
							<NuxtLink v-else-if="item.manufacturer_url_without_domain && item.manufacturer_title" class="cd-brand" :to="item.manufacturer_url_without_domain">{{item.manufacturer_title}}</NuxtLink>
						</div>

						<div class="cd-price-loyalty-cnt">
							<WebshopLoyalty v-slot="{onSubmit, loading, newIsActive, loyalty}">
								<div v-if="item.price_custom > 0" class="cd-price">
									<div>
										<div>																	
											<div v-if="item.discount_percent > 0 || item.price_custom < item.basic_price" class="cd-double-prices">
												<div class="cd-double-price1">
													<div class="cd-current-price red">
														<span><BaseUtilsFormatCurrency :price="item.price_custom" /></span>
														<span v-if="item?.type == 'groupproduct'" class="cd-save cd-save-groupp"><BaseCmsLabel code="price_save_2" /> <BaseUtilsFormatCurrency :price="item.basic_price - item.price_custom" /><span v-if="labels.get('group_product_save_desc')" ref="gppsave" @click="activeSaveTooltip = !activeSaveTooltip" :class="['cd-save-grupp-cnt', activeSaveTooltip && 'active']">i<span><BaseCmsLabel code="group_product_save_desc" /></span></span></span>
														<span v-else class="cd-save"><BaseCmsLabel code="price_save" /> <BaseUtilsFormatCurrency :price="item.basic_price - item.price_custom" /></span>
													</div>
												</div>
											</div>
								
											<div v-else class="cd-double-prices">
												<div class="cd-double-price1">
													<div class="cd-current-price"><BaseUtilsFormatCurrency :price="item.price_custom" /></div>
												</div>
											</div>

											<div v-if="loyalty?.discount_percent && loyalty?.active && item.price_custom" class="cd-loyalty-save">
												<div v-html="labels.get('loyalty_save').replace('%AMOUNT%', formatCurrency(item.price_custom - ((item.price_custom * (1 - (loyalty?.discount_percent / 100)))), {showCurrency: true}))"></div>
											</div>
										</div>
									</div>
									<CatalogUnitPrice :item="item" />

									<div class="cd-tax">
										<BaseCmsLabel code="tax_included" :replace="[{'%TAX%': item.tax*100}]"/>
									</div>

									<span v-if="item.extra_price_lowest && (item.discount_percent || item.discount_percent_custom) && item.extra_price_lowest != 0" class="cd-extra-price-lowest"><BaseCmsLabel code="extra_price_lowest" />: <strong><BaseUtilsFormatCurrency :price="item.extra_price_lowest" /></strong></span>

									<NuxtLink v-if="item.manufacturer_main_image && item.manufacturer_url_without_domain" class="cd-brand-img cd-brand-img-mobile" :to="item.manufacturer_url_without_domain">
										<BaseUiImage :data="item.manufacturer_main_image_thumbs?.['width160-height70']" default="/images/no-image-100.jpg" loading="lazy" />
									</NuxtLink>
								</div>
															
								<div v-if="loyalty?.discount_percent && !loyalty?.active && item.price_custom" class="clear loyalty-w cd-loyalty">
									<!-- <div class="loyalty-cnt-desc">
										<div v-html="labels.get('join_loyalty').replace('%AMOUNT%', formatCurrency(item.price_custom - ((item.price_custom * (1 - (loyalty?.discount_percent / 100)))), {showCurrency: true}))"></div>
										<div v-if="labels.get('loyalty_tooltip_menu')" v-html="labels.get('loyalty_tooltip_menu')" class="cd-loyalty-tooltip"></div>
									</div> -->
									<div class="loyalty-checkbox" :class="{'loading': loading}">
										<input type="checkbox" name="loyalty_request_new" @click.prevent="onSubmit()" id="field-loyalty_request_new" :checked="newIsActive">
										<label for="field-loyalty_request_new" v-interpolation v-html="labels.get('join_loyalty_label_new').replace('%AMOUNT%', formatCurrency(item.price_custom - ((item.price_custom * (1 - (loyalty?.discount_percent / 100)))), {showCurrency: true}))"></label>
									</div>
								</div>
							</WebshopLoyalty>
						</div>

						<ClientOnly>
							<div class="add-to-cart-container" :class="!item.is_available ? 'wide' : ''">
								<WebshopAddToCartContainer :item="item" mode="cd" />

								<CatalogSetWishlist :item="item" mode="detail"/>
							</div>
						</ClientOnly>

						<BaseUiSwiper class="cd-info-cnt" v-interpolation :options="sliderOptions">
							<BaseUiSwiperSlide>
								<div class="cd-info cd-info1" v-if="freeShippingAmount" v-html="labels.get('product_info_delivery').replace('%AMOUNT%', freeShippingAmount)"></div>
							</BaseUiSwiperSlide>
							<BaseUiSwiperSlide>
								<div class="cd-info cd-info2" v-html="labels.get('product_info_promo')"></div>
							</BaseUiSwiperSlide>
							<BaseUiSwiperSlide>
								<div class="cd-info cd-info3" v-html="labels.get('installments_info')"></div>
							</BaseUiSwiperSlide>
						</BaseUiSwiper>

						<div class="product-info">
							<div class="tabs-container cd-tabs-container">
								<div class="tabs-content cd-tabs-content">
									<div v-if="item.content || item.documents?.length" :class="['cd-tab-all cd-tab-desc', {active: activeTabs[1]}]">
										<div class="btn-tab-toggle" @click="activeTabs[1] = !activeTabs[1];"><BaseCmsLabel code="product_about" /><span class="plus"></span></div>
										<div class="tab-cnt">
											<div class="cms-content">
												<div v-if="item.content" v-html="item.content" v-interpolation></div>
												
												<div v-if="item.attributes?.length" class="cd-attributes">
													<div v-for="(attribute, index) in item.attributes" :key="index" class="cd-attr">
														<div v-if="attribute.attribute_title" class="cd-attr-title">{{attribute.attribute_title}}</div>
														<div v-if="attribute.title" class="cd-attr-desc">{{attribute.title}}</div>
													</div>
												</div>

												<ul v-if="item.documents?.length" class="document">
													<li v-for="document in item.documents" :key="document.id">
														<a :href="document.url" target="_blank" :title="document.description || ''">{{document.title || ''}}</a>
													</li>
												</ul>						
											</div>
										</div>
									</div>
									<div v-if="item.element_ingridients" :class="['cd-tab-all cd-tab-ingridients', {active: activeTabs[2]}]">
										<div class="btn-tab-toggle" @click="activeTabs[2] = !activeTabs[2];"><BaseCmsLabel code="product_ingridients" /><span class="plus"></span></div>
										<div class="tab-cnt">
											<div class="cms-content" v-if="item.element_ingridients" v-html="item.element_ingridients" v-interpolation></div>
										</div>
									</div>

									<BaseFaqQuestions :fetch="{catalogproduct_id: item.id, catalogcategory_id: item.category_id, category_code: 'faq_products', limit: 30}" mode="product" v-slot="{items: faqItems}">
										<div v-if="faqItems?.length" :class="['cd-tab-all cd-tab-faq', {active: activeTabs[3]}]">
											<div class="btn-tab-toggle" @click="activeTabs[3] = !activeTabs[3];"><BaseCmsLabel code="product_faq" /><span class="plus"></span></div>
											<div class="tab-cnt">										
												<template v-for="faqItem in faqItems" :key="faqItem.id">
													<CmsFaqItem :item="faqItem" mode="cd" />
												</template>		
											</div>
										</div>
									</BaseFaqQuestions>									

									<div :class="['cd-tab-all cd-tab-inquiry', {active: activeTabs[4]}]">
										<div class="btn-tab-toggle" @click="activeTabs[4] = !activeTabs[4];"><BaseCmsLabel code="product_inquiry" /><span class="plus"></span></div>
										<div class="tab-cnt">
											<ClientOnly>
												<div class="cd-inquiry">
													<div class="cd-inquiry-title"><BaseCmsLabel code="not_available" /></div>
													<BaseFormSiteForm code="contact" class="form-animated-label" v-slot="{fields, loading, status}">
														<template v-if="!status?.success">
															<BaseFormField v-for="field in fields" :key="field.name" :item="field" v-slot="{errorMessage, floatingLabel}">
																<template v-if="field.name == 'subject'">
																	<BaseFormInput type="hidden" :value="'Upit o proizvodu ' + item.title + ', url: ' + item.url" />
																</template>
																<p v-else class="field" :class="['field-' + field.name, {'ffl-floated': floatingLabel}]">
																	<label :for="'inq_'+field.name"><BaseCmsLabel :code="field.name" /></label>
																	<BaseFormInput :id="'inq_'+field.name" />
																	<span class="error" v-show="errorMessage" v-html="errorMessage" />
																</p>
															</BaseFormField>											
															<button :disabled="loading" type="submit" class="btn btn-primary btn-cd-inquiry"><span><UiLoader v-if="loading" /><BaseCmsLabel v-else code="inquiry_send" default="Pošalji" /></span></button>												
														</template>
														<div v-show="status?.success" class="cd-inquiry-success">
															<BaseCmsLabel code="inquiry_success" default="Uspješno slanje"/>
														</div>
													</BaseFormSiteForm>
												</div>
											</ClientOnly>											 
										</div>
									</div>

									<div v-if="item.feedback_comment_widget?.comments_status == 2 && item.feedback_comment_widget?.comments > 0 || item.feedback_comment_widget?.comments_status >= 3"  :class="['cd-tab-all cd-tab-all-comments', {active: activeTabs[5]}]" id="comments">
										<div class="btn-tab-toggle" @click="activeTabs[5] = !activeTabs[5];"><BaseCmsLabel code="comments" /> <small>({{item.feedback_comment_widget?.comments ? item.feedback_comment_widget?.comments : 0}})</small><span class="plus"></span></div>
										<div class="tab-cnt cd-tab-comments">
											<ClientOnly>
												<FeedbackCommentsForm :item="item" />
											</ClientOnly>
										</div>
									</div>								
								</div>
							</div>
						</div>	

						<ClientOnly>
							<BaseCatalogProductsWidget :fetch="{related_code: 'bought_together', related_item_id: item.id}" v-slot="{items, meta}">
								<LazyCatalogBoughtTogether v-if="items?.length" :items="items" :meta="meta" hydrate-on-visible />
							</BaseCatalogProductsWidget>

							<LazyBasePublishPostsWidget :fetch="{related_product_id: item.id, limit: 3, extra_fields: ['short_description'], response_fields: ['id', 'url_without_domain', 'title', 'main_image_thumbs', 'short_description']}" v-slot="{items}">
								<div v-if="items?.length" class="cd-rp-cnt">
									<div class="cd-rp-title">Povezani članci</div>
									<div class="cd-rp-items">
										<PublishIndexEntry v-for="post in items" :item="post" mode="small" :key="post.id" />
									</div>
								</div>
							</LazyBasePublishPostsWidget>
						</ClientOnly>   						

						<div class="cd-share">
							<CmsShare />
						</div>
					</div>
				</div>
			</div>
		</div>
		<ClientOnly>
			<BasePublishCategory :fetch="{code: 'instashop', response_fields: ['id','code','url_without_domain']}" v-slot="{item: list}">
				<BasePublishPosts :fetch="{category_code: list.code, imagemapitem: item.id, extra_data: ['images']}" v-slot="{items}" v-if="list?.code">
					<div v-if="items?.length" class="instashop-details">
						<div class="wider-wrapper">
							<LazyPublishInstashopContent :instashopData="items" mode="details" hydrate-on-visible />
						</div>
					</div>
				</BasePublishPosts>
			</BasePublishCategory>

			<BaseCatalogProductsWidget :fetch="{related_code: 'related', related_item_id: item.id, related_widget_data: item.related_widget_data, always_to_limit: true, limit: 20}" v-slot="{items: relatedProducts}" :gtm-tracking="{item_list_id: 'related', item_list_name: labels.get('related_products')}" @loadProductsWidget="onLoadedProducts">
				<BaseCatalogProductsWidget :fetch="{related_code: 'up_sale', related_item_id: item.id, related_widget_data: item.related_widget_data, always_to_limit: true, limit: 20}" v-slot="{items: upsaleProducts}" :gtm-tracking="{item_list_id: 'up_sale', item_list_name: labels.get('upsale_products')}" @loadProductsWidget="onLoadedProducts">
					<BaseCatalogProductsWidget :fetch="{sort: 'last_view', limit: 20, id_exclude: item.id, special_view: 'viewed'}" :cache="false" v-slot="{items: lastViewProducts}">
						<div v-if="relatedProducts.length || upsaleProducts.length || lastViewProducts.length" class="special-products cd-special-products">
							<div class="wider-wrapper">
								<div v-if="relatedProducts.length" class="cd-related-products">
									<div class="cd-special-products-title"><BaseCmsLabel code="related_products" /></div>
									<div class="special-slider cd-special-slider">														
										<CatalogSpeciallists :items="relatedProducts" :perPage="4" />		
									</div>
								</div>

								<div v-if="upsaleProducts.length" class="cd-related-products cd-upsale-products">
									<div class="cd-special-products-title"><BaseCmsLabel code="upsale_products" /></div>
									<div class="special-slider cd-special-slider">														
										<CatalogSpeciallists :items="upsaleProducts" :perPage="4" />		
									</div>
								</div>

								<div v-if="lastViewProducts.length" class="cd-related-products cd-lastviewed-products">
									<div class="cd-special-products-title"><BaseCmsLabel code="last_viewed_products" /></div>
									<div class="special-slider cd-special-slider">														
										<CatalogSpeciallists :items="lastViewProducts" :perPage="4" />		
									</div>
								</div>
							</div>
						</div>
					</BaseCatalogProductsWidget>
				</BaseCatalogProductsWidget>
			</BaseCatalogProductsWidget>
		</ClientOnly>
	</BaseCatalogDetail>
</template>

<script setup>
	const {scrollTo, onMediaQuery, prependTo, appendTo, insertBefore, onClickOutside} = useDom();
	const labels = useLabels();
	const {gtmTrack} =  useGtm();
	const activeSlide = ref(0);
	const hasSpecialBadges = ref(false);
	const mainSwiper = ref(null);
	const setMainSwiper = (swiper) => {
		mainSwiper.value = swiper;	
	};

    const {getCartData} = useWebshop();
    const {formatCurrency} = useCurrency();
    const freeShippingAmount = computed(() => {
        const amount = getCartData()?.cart?.total_extra_shipping_to_free?.above;
        return amount ? formatCurrency(amount, {showCurrency: true}) : ' ';
    });

	const activeTabs = ref({});
	
	const activeSaveTooltip = ref(false);
	const gppsave = ref();
	onClickOutside(gppsave, () => {
		activeSaveTooltip.value = false;
	});


	function onLoad(data) {
		if(data.item?.attributes_special?.some(a => a.attribute_code === 'posebne_oznake')){
			hasSpecialBadges.value = true;
		}	
	}	

	const sliderOptions = {
		slidesPerView: 1,
		slidesPerGroup: 1,
		speed: 500,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		loop: true,
		autoplay: {
			delay: 3500,
			disableOnInteraction: true
		},
		navigation: {
			enabled: false,
		},
		breakpoints: {
			760: {
				enabled: false,
			}
		}
	}	

	onMediaQuery({
		query: '(max-width: 760px)',
		enter: () => {
			prependTo('.cd-col2-intro-cnt', '.cd-header');
			prependTo('.cd-col2 .cd-scarcity-watching', '.cd-col1');
			prependTo('.cd-col2 .bc', '.cd-col1');
			appendTo('.cd-share .share', '.cd-col2');
			insertBefore('.cd-video-url', '.cd-info-cnt');
		},
	});

	
	function onLoadedProducts(products){
		if (products?.items.length) {
			let finalItems = [];
			products.items.forEach((item,index) => {
				finalItems.push(
					{
						id: item.id,
						name: item.title ? item.title : '',
						category: item.category_title ? item.category_title : '',
						brand: item.manufacturer_title ? item.manufacturer_title : '',
						position: index+1,
						price: item.price_custom ? item.price_custom : '',
					},
				)
			});
			gtmTrack('productDetailImpressions', {
				ecommerce: {
					detail: {
						actionField: {
							list: 'detail'
						},
						products: finalItems
					}
				}
			}, {custom: true});
		}
	}
	
</script>

<style lang="less" scoped>
	.add-to-cart-container.wide{
		flex-flow: column;
		:deep(.cd-wishlist){
			margin-left: 0; margin-top: 32px;
			.cd-wishlist-btn{
				width: 100%; font-size: 18px;
				&:before{position: relative; margin-right: 12px;}
			}
			@media (max-width: @t){margin-top: 20px;}
			@media (max-width: @tp){
				margin-top: 16px;
				.cd-wishlist-btn{
					font-size: 16px;
					&:before{margin-right: 9px;}
				}
			}
			@media (max-width: @m){
				.cd-wishlist-btn{
					font-size: 16px;
					&:before{margin-right: 9px; top: -3px;}
				}
			}
		}
	}
	.cd-rp-title{
		font-weight: bold; font-size: 30px; line-height: 36px; padding: 50px 0 12px;
		@media (max-width: @t){font-size: 24px; line-height: 30px; padding-top: 40px;}
	}
	:deep(.cd-rp-items){
		.pp{
			margin-bottom: 16px; align-items: center;
			@media (min-width: @h){
				&:hover{box-shadow: 0 0px 20px 0 rgba(85, 41, 122, 0.2);}
			}
			@media (max-width: @m){margin-bottom: 12px;}
		}
		.pp-image{
			width: 192px;
			@media (max-width: @m){width: 160px;}
		}
		.pp-cnt{
			padding: 10px 0 10px 25px;
			@media (max-width: @m){padding-left: 16px;}
		}
		.pp-title{
			@media (max-width: @tp){font-size: 18px; line-height: 21px; font-weight: 400; color: var(--textColor);}
		}
	}

	.cd-scarcity-watching{
		font-size: 16px; line-height: 20px; color: #fff; display: inline-block; vertical-align: top; background: var(--primaryColor); position: relative; padding: 6px 11px 4px 37px; border-radius: 2px; margin-bottom: 12px;
		@media (max-width: @m){font-size: 14px; line-height: 18px;}
		&:before{
			position: absolute; .icon-danger-white; font: 18px/18px var(--fonti); color: #fff; left: 12px; top: 6px;
			@media (max-width: @m){font-size: 16px; line-height: 16px;}
		}
	}

	.cd-groupp-cnt{padding: 16px 0 4px;}
	.cd-groupp-title{font-size: 18px; line-height: 21px; font-weight: bold; padding-bottom: 8px;}
	.cd-groupp-item{
		font-size: 18px; line-height: 24px; font-weight: normal; margin-bottom: 10px;
		a{
			display: inline-block;
			@media (min-width: @h){
				&:hover{text-decoration: none;}
			}
		}
	}

	.instashop-details{
		padding: 72px 0 80px; position: relative; display: block;
		@media (max-width: @t){padding: 50px 0;}
		@media (max-width: @tp){padding: 40px 0 0;}
	}

	.cd-badge-coupon{position: relative;}
	.cd-badge-coupon-img{
		display: flex; align-items: center; justify-content: center; width: 72px; aspect-ratio: 1;
		@media (max-width: @l){width: 53px;}
		@media (max-width: @m){width: 54px;}
	}
	.cd-badge-coupon-text{
		font-size: 16px; line-height: 19px; border-radius: 2px; font-weight: bold; height: 30px; display: flex; align-items: center; padding: 0 10px; white-space: nowrap; position: absolute; left: 0;
		@media (max-width: @t){font-size: 14px; line-height: 18px; height: 22px;}
	}

	.cd-loyalty{
		width: 350px; padding-left: 0; padding-right: 87px;
		&:before{left: unset; right: 0; top: 0;}
		@media (max-width: @t){width: 315px; padding-right: 75px;}
		@media (max-width: @tp){width: 295px; padding-right: 55px;}
		@media (max-width: @m){
			width: 100%; padding-right: 100px;
			&:before{width: 88px; height: 53px;}
		}
	}
	.loyalty-checkbox{
		input[type=checkbox] + label, input[type=radio] + label{
			font-size: 16px; padding-top: 5px; font-weight: normal;
			:deep(strong){color: var(--primaryColor);}
			:deep(p){padding-bottom: 0; font-size: 16px;}
			@media (max-width: @t){
				font-size: 14px; line-height: 19px;
				:deep(p){font-size: 14px; line-height: 19px;}
			}
			@media (max-width: @m){
				font-size: 16px; line-height: 19px; padding-top: 4px; min-height: 53px;
				:deep(p){font-size: 16px; line-height: 19px;}
			}
		}
	}
	.cd-col1{
		@media (max-width: @m){
			position: relative;
			&:after{.pseudo(58px, 20px); right: -15px; top: 0; background: linear-gradient(90deg,  rgba(255,255,255,0) 0%, rgba(255,255,255,100) 100%);}
		}
	}
</style>